import RecoveryAgent from "@/models/recoveryAgent.model";
import ApiService from "@/services/api.service";

class RecoveryAgentService extends ApiService {
  constructor() {
    super();
  }

  public async getActive(): Promise<RecoveryAgent[]> {
    const url = "/api/RecoveryAgents";
    const response = await this.axiosInstance.get<RecoveryAgent[]>(url);
    return (response.data || []).map((item) => new RecoveryAgent(item));
  }

  public async remove(agentEmail: string): Promise<boolean> {
    const url = `/api/RecoveryAgents/${encodeURIComponent(agentEmail)}`;
    const response = await this.axiosInstance.delete(url);
    return response.status === 204;
  }

  public async create(agent: any): Promise<boolean> {
    const url = `/api/RecoveryAgents`;
    const response = await this.axiosInstance.post(url, {
      ...agent,
      preferredLanguage: "EN"
    });
    return response.status === 202;
  }
}

export default new RecoveryAgentService();
